import Auth from '../modules/Authentication'
import { formatQueryParams, handleErrors, handleResponse } from '../modules/Utils'
import { apiUrl } from '../variables'
import { isEmpty } from 'lodash'

const headers = {}
const auth = new Auth()

export default class Budgets {
  list = (budgetType) => {
    const select = '*'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/?select=${select}${formatQueryParams('budgetType', budgetType)}`, { headers })
      .then(handleErrors)
      .then(handleResponse)
  }
  read = (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/${key}`, { headers }).then(handleErrors).then(handleResponse)
  }
  reqs = (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/${key}/reqs`, { headers }).then(handleErrors).then(handleResponse)
  }
  create = (data, id, contract) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/${formatQueryParams('id', id, true)}${formatQueryParams('contract', contract)}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  createValuesWithAutoLine = (data, id, contract) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(
      `${apiUrl}budgets/AutoLines${formatQueryParams('id', id, true)}${formatQueryParams('contract', contract)}`,
      {
        headers,
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
      .then(handleErrors)
      .then(handleResponse)
  }

  existing = (data, id) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/existing${formatQueryParams('id', id, true)}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  createWithLines = (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/WithLines`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  update = (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/`, {
      headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  operation = (key, data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/${key}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  remove = (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/`, {
      headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  lines = {
    list: (key) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}budgets/${key}/lines/`, { headers }).then(handleErrors).then(handleResponse)
    },
    add: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}budgets/lines`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    deliver: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}budgets/lines/deliver`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}budgets/lines`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}budgets/lines`, {
        headers: headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  current = (id) => {
    if (isEmpty(id)) return {}
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/current/${formatQueryParams('id', id, true)}`, { headers })
      .then(handleErrors)
      .then(handleResponse)
  }
}

export const Lines = {
  list: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/${key}/lines`, { headers }).then(handleErrors).then(handleResponse)
  },
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/lines`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: (data, key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/lines`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: (data, key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}budgets/lines`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  },
}
